import { render, staticRenderFns } from "./FeedbackSuperAdminPreSelect.vue?vue&type=template&id=0116d4d1"
import script from "./FeedbackSuperAdminPreSelect.vue?vue&type=script&lang=js"
export * from "./FeedbackSuperAdminPreSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports